<template>
  <div id="DahHistoryTable">
    <div v-if="noCustomerHistory" class="container">
      <div class="section" style="padding-top: 3rem !important">
        <p class="subtitle is-6" style="color: #8c8c8c;">
          {{ noCustomerHistory }}
        </p>
      </div>
    </div>
    <div v-else class="container">
      <!-- Customer History List -->
      <b-table :data="customerHistory" :striped="true">
        <template slot-scope="props">
          <b-table-column
            field="create_date"
            :label="$t('customer.tabs.table.created')"
            >{{ props.row.created.time | dateformatter }}</b-table-column
          >
          <b-table-column
            field="event"
            :label="$t('customer.tabs.table.cust_history.event')"
            >{{ props.row.event }}</b-table-column
          >
          <b-table-column
            field="old_data"
            :label="$t('customer.tabs.table.cust_history.old')"
          >
            <!-- distance -->
            <p v-if="props.row.event === 'distance' && props.row.old_data">
              {{ props.row.old_data.lock_distance | todecimal(2) }} m.
            </p>
            <!-- imei -->
            <p v-else-if="props.row.event === 'imei' && props.row.old_data">
              imie: {{ props.row.old_data.imei }}
              <br />
              esn: {{ props.row.old_data.esn }}
            </p>
            <!-- location -->
            <p v-else-if="props.row.event === 'location' && props.row.old_data">
              {{ props.row.old_data.location }}
            </p>
            <!-- contact_number -->
            <p
              v-else-if="
                props.row.event === 'contact_number' && props.row.old_data
              "
            >
              {{ props.row.old_data.contact_number }}
            </p>
            <!-- om -->
            <p v-else-if="props.row.event === 'om' && props.row.old_data">
              {{ props.row.old_data }}
            </p>
            <!-- other -->
            <p v-else-if="props.row.event === 'other' && props.row.old_data">
              {{ props.row.old_data }}
            </p>
            <p v-else>-</p>
          </b-table-column>
          <b-table-column
            field="new_data"
            :label="$t('customer.tabs.table.cust_history.new')"
          >
            <!-- distance -->
            <p v-if="props.row.event === 'distance' && props.row.new_data">
              {{ props.row.new_data.lock_distance | todecimal(2) }} m.
            </p>
            <!-- imei -->
            <p v-else-if="props.row.event === 'imei' && props.row.new_data">
              imie: {{ props.row.new_data.imei }}
              <br />
              esn: {{ props.row.new_data.esn }}
            </p>
            <!-- location -->
            <p v-else-if="props.row.event === 'location' && props.row.new_data">
              {{ props.row.new_data.location }}
            </p>
            <!-- contact_number -->
            <p
              v-else-if="
                props.row.event === 'contact_number' && props.row.new_data
              "
            >
              {{ props.row.new_data.contact_number }}
            </p>
            <!-- om -->
            <p v-else-if="props.row.event === 'om' && props.row.new_data">
              {{ props.row.new_data }}
            </p>
            <!-- other -->
            <p v-else-if="props.row.event === 'other' && props.row.new_data">
              {{ props.row.new_data }}
            </p>
            <p v-else>-</p>
          </b-table-column>
          <b-table-column
            field="created_by"
            :label="$t('customer.tabs.table.cust_history.create_by')"
            >{{ props.row.created.email }}</b-table-column
          >
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import AlertManager from "@/managers/AlertManager";
import CustomerApiManager from "@/apis/CustomerApiManager";

export default {
  name: "DahHistoryTable",
  props: ["customer_id", "enable"],
  data() {
    return {
      noCustomerHistory: null,
      customerHistory: []
    };
  },
  watch: {
    enable: function(val) {
      if (val) this.getCustomerUpdateHistory();
    }
  },
  filters: {
    todecimal: function(value, decimal_place) {
      if (!value) return "";
      return Number(value).toFixed(decimal_place);
    },
    dateformatter: function(value) {
      if (!value) return "";
      return dayjs(value).format("DD/MM/YYYY @ HH:mm");
    }
  },
  methods: {
    getCustomerUpdateHistory: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const customerHistoryResult = await CustomerApiManager.requestDahHistory(
        this.customer_id
      );
      loadingComponent.close();

      switch (customerHistoryResult.code) {
        case "0":
          if (customerHistoryResult.data.history.length > 0) {
            this.noCustomerHistory = null;
            this.customerHistory = customerHistoryResult.data.history.reverse();
          } else {
            this.noCustomerHistory = this.$t(
              "customer.tabs.table.cust_history.not_found"
            );
          }
          break;

        default:
          AlertManager.showErrorSnackbar(customerHistoryResult.message);
          break;
      }
    }
  },
  mounted() {
    if (this.enable) this.getCustomerUpdateHistory();
  }
};
</script>

<style></style>
